package fr.arcplex.sooner.ui.theme

import androidx.compose.ui.graphics.Color

// TV / home colors — fallback defaults sourced from CoherenceTheme.DEFAULT.
// At runtime these are replaced by values fetched from /api/box/theme/defaults.
val TVBackground = Color(0xFF0B0E12)
val TVSurface = Color(0xFF171B21)
val TVPanel2 = Color(0xFF222C3D)
val TVLine = Color(0xFF2C3A4F)
val TVTxt = Color(0xFFE6EDF3)
val TVMuted = Color(0xFFA2A3A5)
val TVAccent = Color(0xFFFFFFFF)
val TVAccent2 = Color(0xFF305496)
val TVPlay = Color(0xFFF247F5)
val TVNormal = Color(0xFFF247F5)
val TVPrimary = Color(0xFFF247F5)
val TVPrimaryVariant = Color(0xFF305496)
val TVSecondary = Color(0xFFF247F5)
val TVOnBackground = Color(0xFFF2F5F8)
val TVOnSurface = Color(0xFFF2F5F8)
val TVFocusHighlight = Color(0xFFFFFFFF)
val TVOverlay = Color(0x80000000)
